import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./i18n";
import { AuthProvider, Protected } from "./lib/auth";
import { Header, Footer } from "./components/Layout";
import Landing from "./pages/Landing";
import { Login, Register, Forgot, Reset, VerifyEmail } from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import ProfileEditor from "./pages/ProfileEditor";
import PublicProfile from "./pages/PublicProfile";
import Search from "./pages/Search";
import { EntityList, CommunityDetail, GroupDetail } from "./pages/Social";
import Messages from "./pages/Messages";
import { Notifications, Invitations } from "./pages/Inbox";
import Employer from "./pages/Employer";
import Admin from "./pages/Admin";
import Settings from "./pages/Settings";
import { StaticPage, Learn } from "./pages/Static";

const P = (el, role) => <Protected role={role}>{el}</Protected>;

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="min-h-screen flex flex-col">
            <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:p-2 focus:bg-white">Skip to content</a>
            <Header />
            <main id="main" className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<Forgot />} />
                <Route path="/reset-password" element={<Reset />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/onboarding" element={P(<Onboarding />)} />
                <Route path="/dashboard" element={P(<Dashboard />)} />
                <Route path="/profile/edit" element={P(<ProfileEditor />)} />
                <Route path="/u/:username" element={<PublicProfile />} />
                <Route path="/search" element={<Search />} />
                <Route path="/communities" element={<EntityList kind="communities" />} />
                <Route path="/c/:slug" element={P(<CommunityDetail />)} />
                <Route path="/groups" element={<EntityList kind="groups" />} />
                <Route path="/g/:slug" element={<GroupDetail />} />
                <Route path="/messages" element={P(<Messages />)} />
                <Route path="/messages/:id" element={P(<Messages />)} />
                <Route path="/notifications" element={P(<Notifications />)} />
                <Route path="/invitations" element={P(<Invitations />)} />
                <Route path="/employer" element={P(<Employer />, "employer")} />
                <Route path="/admin" element={P(<Admin />, "admin")} />
                <Route path="/settings" element={P(<Settings />)} />
                <Route path="/learn" element={<Learn />} />
                <Route path="/:page" element={<StaticPage />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
  );
}
